import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

/** Renders the todo type icon (by icon name or emoji). */
export function TodoTypeIcon({
  icon,
  tt_descr,
  className = 'w-3.5 h-3.5 shrink-0',
}: {
  icon?: string | null;
  tt_descr?: string;
  className?: string;
}) {
  const { colors } = useTheme();
  const name = (icon || '').trim().toLowerCase();
  if (name && name.length <= 2 && !/^[a-z-]+$/.test(name)) {
    return <span className={cn('shrink-0 text-sm leading-none', className)} aria-hidden>{name}</span>;
  }
  const svgClass = className;
  switch (name) {
    case 'phone':
      return (
        <svg className={svgClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
      );
    case 'phone-arrow-up-right':
      return (
        <svg className={svgClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 7l5 5m0 0l-5 5m5-5H10" />
        </svg>
      );
    case 'clipboard-check':
      return (
        <svg className={svgClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      );
    case 'document-text':
      return (
        <svg className={svgClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      );
    case 'document-duplicate':
      return (
        <svg className={svgClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      );
    default:
      if (!tt_descr) return null;
      return (
        <span className={cn('shrink-0 text-[10px] font-medium uppercase truncate max-w-[2rem]', colors.textMuted, className)} title={tt_descr}>
          {tt_descr.slice(0, 1)}
        </span>
      );
  }
}
